import { FunctionComponent } from "react"
import { AGOLIntegrationUI } from "./AGOLIntegrationUI"
import { isAuthExpired } from "integrations/oauth/oauthHelpers"
import { AuthorizationType } from "@nova/db-table-integration-authorizations"
import { TAKIntegrationUI } from "./tak/TAKIntegrationUI"
import { CalTopoIntegrationUI } from "./caltopo/CalTopoIntegrationUI"
import type { IntegrationAuthorizationResponse } from "@nova/data-facade"
import { IntegrationType } from "@nova/schemas"
import { useAppSelector } from "integrations/redux/hooks"
import { selectUserID } from "user/profile/selectors"

interface ExtraIntegrationUIProps {
    authorization: IntegrationAuthorizationResponse
}
const ExtraIntegrationUI: FunctionComponent<ExtraIntegrationUIProps> = ({ authorization }) => {
    const selfId = useAppSelector(selectUserID)

    switch (authorization.integration) {
        case IntegrationType.agol:
            return isAuthExpired(authorization) || authorization.userId !== selfId ? (
                <></>
            ) : (
                <AGOLIntegrationUI
                    authorization={
                        authorization as IntegrationAuthorizationResponse<
                            AuthorizationType,
                            IntegrationType.agol
                        >
                    }
                />
            )
        case IntegrationType.tak:
            return (
                <TAKIntegrationUI
                    authorization={
                        authorization as IntegrationAuthorizationResponse<
                            AuthorizationType,
                            IntegrationType.tak
                        >
                    }
                />
            )

        case IntegrationType.caltopo:
            return (
                <CalTopoIntegrationUI
                    authorization={
                        authorization as IntegrationAuthorizationResponse<
                            AuthorizationType,
                            IntegrationType.caltopo
                        >
                    }
                />
            )

        default:
            return <></>
    }
}

export { ExtraIntegrationUI }
